import { initializeApp } from "firebase/app";
import { getMessaging, isSupported } from "firebase/messaging";

const firebaseConfig = {
	apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
	authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
	projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
	storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
	messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
	appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);

let messaging = null;
if (typeof window !== "undefined") {
	isSupported().then((supported) => {
		if (supported) {
			messaging = getMessaging(app);
			console.log("✅ Firebase Messaging initialized");
		} else {
			console.warn("🚫 Firebase Messaging not supported in this browser");
		}
	});
}

export { app, messaging, isSupported };
